import type { GetAllResolvedEdiblesResponse } from "api-types";
import type { AxiosInstance } from "axios";
import { getAllResolvedEdibles } from "igfd-commons";

import type { ResolvedEdiblesState } from "@dashboard/types";

export interface ResolvedEdiblesApi {
  fetchResolvedEdibles(
    restaurantUuid: string
  ): Promise<GetAllResolvedEdiblesResponse>;
}

/**
 * An implementation of the DishApi that uses Firestore as the backend.
 */
export class ResolvedEdiblesBackend implements ResolvedEdiblesApi {
  private client: AxiosInstance;

  constructor(params: { axiosClientWithoutAuth: AxiosInstance }) {
    this.client = params.axiosClientWithoutAuth;
  }

  public fetchResolvedEdibles(
    restaurantUuid: string
  ): Promise<GetAllResolvedEdiblesResponse> {
    return getAllResolvedEdibles(this.client, restaurantUuid)
      .then((response) => {
        if (response === undefined) {
          throw new Error("Error fetching resolved edibles");
        }
        return response;
      })
      .catch((error) => {
        console.error("Error fetching resolved edibles", error);
        throw error;
      });
  }
}
